"use client"

import React, { useState } from 'react';

export default function CommunionPage() {
  const [receivedBody, setReceivedBody] = useState(false);
  const [receivedBlood, setReceivedBlood] = useState(false);

  const bothReceived = receivedBody && receivedBlood;

  return (
    <main className="min-h-screen bg-white text-stone-900 font-serif flex items-start justify-center py-12">
      <div className="w-full max-w-3xl px-6">
        <div className="text-center">
          <img src='/crucifixj.jpg' alt="Crucifix" width={100} className="mx-auto mb-6" />
        </div>

        <div className="bg-stone-100 rounded-lg shadow-sm p-6">
          <div className="flex flex-col md:flex-row items-start md:items-center gap-8 md:gap-12 justify-center">

            <div className="flex-1 text-center">
              <div className="mb-2 text-sm font-bold uppercase text-amber-800">The Body of Christ</div>

              <div className={`mx-auto w-36 h-36 flex items-center justify-center ${receivedBody ? 'filter brightness-75' : ''}`}>
                <svg viewBox="0 0 64 64" width="96" height="96" xmlns="http://www.w3.org/2000/svg">
                  <ellipse cx="32" cy="32" rx="26" ry="18" fill={receivedBody ? '#d6b88a' : '#f3d9b6'} stroke="#b5834a" strokeWidth="2" />
                  <path d="M18 28c5 4 11 4 17 0" stroke="#b08342" strokeWidth="1.5" fill="none" strokeLinecap="round" />
                  <path d="M20 34c6 4 10 4 24 0" stroke="#b08342" strokeWidth="1.2" fill="none" strokeLinecap="round" opacity="0.7" />
                </svg>
              </div>

              <div className="mt-4">
                {!receivedBody ? (
                  <button
                    onClick={() => setReceivedBody(true)}
                    className="bg-amber-800 hover:bg-amber-950 text-stone-100 px-4 py-2 rounded uppercase text-xs font-medium"
                  >
                    Amen
                  </button>
                ) : (
                  <span className="text-sm font-semibold text-stone-700">Received</span>
                )}
              </div>
            </div>

            <div className="flex-1 text-center">
              <div className="mb-2 text-sm font-bold uppercase text-amber-800">The Blood of Christ</div>

              <div className={`mx-auto w-36 h-36 flex items-center justify-center ${receivedBlood ? 'filter brightness-75' : ''}`}>
                <svg viewBox="0 0 64 64" width="96" height="96" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Chalice">
                  {/* Bowl */}
                  <path d="M12 20 C18 34 46 34 52 20 L52 26 C52 36 40 42 32 42 C24 42 12 36 12 26 Z" fill={receivedBlood ? '#8a2b2b' : '#c13b3b'} stroke="#6f1f1f" strokeWidth="1" />
                  {/* Stem */}
                  <rect x="29" y="38" width="6" height="8" rx="2" fill={receivedBlood ? '#b36b3b' : '#c99b6b'} stroke="#7a5532" strokeWidth="1" />
                  {/* Base */}
                  <ellipse cx="32" cy="50" rx="14" ry="4" fill={receivedBlood ? '#9b6b3b' : '#c99b6b'} stroke="#7a5532" strokeWidth="1" />
                  {/* Highlight on bowl */}
                  <path d="M18 24 C24 30 40 30 46 24" stroke="rgba(255,255,255,0.18)" strokeWidth="2" fill="none" strokeLinecap="round" />
                </svg>
              </div>

              <div className="mt-4">
                {!receivedBlood ? (
                  <button
                    onClick={() => setReceivedBlood(true)}
                    className="bg-amber-800 hover:bg-amber-950 text-stone-100 px-4 py-2 rounded uppercase text-xs font-medium"
                  >
                    Amen
                  </button>
                ) : (
                  <span className="text-sm font-semibold text-stone-700">Received</span>
                )}
              </div>
            </div>

          </div>

          {bothReceived && (
            <div className="mt-8 text-center text-amber-800 font-semibold">
              You have received holy communion. <span className="text-red-600">❤</span>
            </div>
          )}
        </div>
      </div>
    </main>
  );
}
